export default __webpack_public_path__ + "static/media/informado.87690443.png";